export default __webpack_public_path__ + "static/media/DMI-620.af060e33.png";